// hooks/useScrollToElement.ts
import { useEffect, useRef } from 'react';

type ScrollOptions = {
  behavior?: ScrollBehavior;
  block?: ScrollLogicalPosition;
  inline?: ScrollLogicalPosition;
};

export function useScrollToElement<T extends HTMLElement>(
  trigger: boolean,
  options?: ScrollOptions
) {
  const ref = useRef<T | null>(null);

  useEffect(() => {
    if (trigger && ref.current) {
      const element = ref.current;
      const headerOffset = 75;

      const elementTop = element.getBoundingClientRect().top + window.scrollY;
      const scrollTo = elementTop - headerOffset;

      window.scrollTo({
        top: scrollTo,
        behavior: 'smooth',
      });
    }
  }, [trigger, options]);

  return ref;
}
